import { DI } from '@intigral/constant/config/DIContainer';
import { IListReminderUseCase } from '../../core/usecases/reminder/ListReminderUseCase';
import { ISetReminderUseCase } from '../../core/usecases/reminder/SetReminderUseCase';
import { IUnSetReminderUseCase } from '../../core/usecases/reminder/UnSetReminderUseCase';
import { container } from '../../DataDomain';
import {
    IReminderListParams,
    IReminderListResponse,
    IReminderResponse,
    IReminderSetRequest,
    IReminderSetResponse,
    IReminderUnSetRequest,
} from '../../entity/interface/iReminder';

export interface IReminderService {
    setReminder(
        apiKey: string,
        payload: IReminderSetRequest,
        token: string,
        identityToken: string,
        lang: string,
        type: string
    ): Promise<IReminderSetResponse>;
    unSetReminder(
        apiKey: string,
        payload: IReminderUnSetRequest,
        token: string,
        identityToken: string
    ): Promise<IReminderResponse>;
    listReminder(
        apiKey: string,
        searchParams: IReminderListParams,
        token: string,
        identityToken: string
    ): Promise<IReminderListResponse>;
}

export class ReminderService implements IReminderService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get setReminderUseCase(): ISetReminderUseCase {
        return container.resolve<ISetReminderUseCase>(DI.USECASES.ISetReminderUseCase);
    }

    private get unSetReminderUseCase(): IUnSetReminderUseCase {
        return container.resolve<IUnSetReminderUseCase>(DI.USECASES.IUnSetReminderUseCase);
    }

    private get listReminderUseCase(): IListReminderUseCase {
        return container.resolve<IListReminderUseCase>(DI.USECASES.IListReminderUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async setReminder(
        apiKey: string,
        payload: IReminderSetRequest,
        token: string,
        identityToken: string,
        lang: string,
        type: string
    ): Promise<IReminderSetResponse> {
        return await this.setReminderUseCase.execute(apiKey, payload, token, identityToken, lang, type);
    }

    async unSetReminder(
        apiKey: string,
        payload: IReminderUnSetRequest,
        token: string,
        identityToken: string
    ): Promise<IReminderResponse> {
        return await this.unSetReminderUseCase.execute(apiKey, payload, token, identityToken);
    }

    async listReminder(
        apiKey: string,
        searchParams: IReminderListParams,
        token: string,
        identityToken: string
    ): Promise<IReminderListResponse> {
        return await this.listReminderUseCase.execute(apiKey, searchParams, token, identityToken);
    }
}
